module.exports = __webpack_public_path__ + "media/1_3.1c11d63d.wav";